export abstract class LoggerService {
    /**
     * Log the message
     */
    abstract log(msg: string) : void;

    /**
     * Log an error message
     */
    abstract error(msg: string) : void;

    /**
     * Log a warning message
     */
    abstract warn(msg: string) : void;
}
